import { createReducer, on } from "@ngrx/store";
import { TableComponentState } from "../../shared/types/TableComponentState";
import { InitReleaseActions } from "../actions";

export const createRuleTableStateKey = 'createRuleTableState';

export interface State extends TableComponentState {

}

export const initialCreateRuleTableState: State = {
    loading: false,
    error: '',
    hasError: false,
    gridReady: false,
    isInitialLoad: true,
    printClicked: false,
    hasEmptyResponse: false
}

export const createRuleTableStateReducer = createReducer(
    initialCreateRuleTableState
);